import AuthManager from "./AuthManager";

const UserManager = {
    name: "user",
    getUser: () => {
        const user = localStorage.getItem(UserManager.name);
        if (user !== undefined) return JSON.parse(user);
        return null;
    },
    validToken: (e) => {
        if (e.data.message === "Unauthorized" && e.data.statusCode === 401) {
            return false;
        } else {
            return true;
        }
    },
    isLogin: () => {
        const user = localStorage.getItem(UserManager.name);
        if (user !== null && AuthManager.isTokenValid()) {
            return true;
        }
        return false;
    },
    removeUser: () => {
        localStorage.removeItem(UserManager.name);
    },
    getUserPhone: () => {
        const user = UserManager.getUser();
        if (user === null) {
            return "";
        }
        return user.phones.find((userphone) => userphone.type === 3);
    },
    logout: () => {
        UserManager.removeUser();
        AuthManager.removeAuth();
        window.location.reload();
    },
    clearUserAndTokenFromLocalStorage: () => {
        UserManager.removeUser();
        AuthManager.removeAuth();
    },
};

export default UserManager;
